// src/services/vehicleInvoiceService.js
import API_BASE from "../config/api";


export const getVehicles = async (type, fromDate = "", toDate = "") => {

  const token = localStorage.getItem("token");

  let url = `${API_BASE}/ProformaInvoice/List?type=${type}`;

  // add date params only when needed
  if (type !== 1 && fromDate && toDate) {
    url += `&from=${fromDate}&to=${toDate}`;
  }

  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Access-Token": token
    }
  });

  if (!response.ok) {
    throw new Error("Failed to fetch vehicles");
  }

  return await response.json();
};